import CircularProgress from '@mui/material/CircularProgress'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'
import { useTranslation } from 'react-i18next'

/** @notExported */
interface ILoadingIndicatorProps {
  /** The value of the loading indicator. */
  value: number
  /** The action to perform when the loading indicator is clicked. */
  action?: (open: boolean) => void
  /** The tooltip text. */
  tooltip: string
}

/**
 * The LoadingIndicator component.
 *
 * @param value - The value of the loading indicator.
 * @param action - The action to perform when the loading indicator is clicked.
 * @param tooltip - The tooltip text.
 * @returns The LoadingIndicator component.
 * @notExported
 */
const ProgressCircle: React.FC<ILoadingIndicatorProps> = ({ value, action, tooltip }) => {
  const { t } = useTranslation()

  return (
    <Tooltip title={String(tooltip)}>
      <IconButton
        data-testid="button-profile-progress-circle"
        aria-label={String(tooltip)}
        onClick={() => {
          if (action) action(true)
        }}
        style={{ cursor: 'pointer' }}
        size="large"
      >
        <CircularProgress
          variant="determinate"
          value={value}
          color="secondary"
          size={24}
          aria-valuetext={String(tooltip)}
          aria-label={t('profile.progressTitle')}
        />
      </IconButton>
    </Tooltip>
  )
}

export default ProgressCircle
